<template>
  <div class="home">
    <!-- 标题 -->
    <Top />
    <!-- 顶部轮播图 -->
    <CarouselTop></CarouselTop>
    <!-- 内容登录部分 -->
    <div class="content">
      <el-row>
        <el-col :span="12"><Dynamic></Dynamic></el-col>
        <el-col :span="8" :offset="4"><Login></Login></el-col>
      </el-row>
    </div>
    <CopyRight></CopyRight>
    <FooterMobile></FooterMobile>
  </div>
</template>

<script>
import Top from '@/components/Top.vue'
import CarouselTop from '@/components/CarouselTop.vue'
import Dynamic from '../components/Dynamic'
import Login from '../components/login'
import CopyRight from '../components/CopyRight'
import FooterMobile from '../components/footerMobile'

export default {
  name: 'Home',
  components: {
    Top,
    CarouselTop,
    Dynamic,
    Login,
    CopyRight,
    FooterMobile
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.content {
  @include autoInner;
  margin-top: 50px;
}
</style>
